import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import {Router} from '@angular/router';

import { User } from '../users/user';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment'




@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  titulo = 'Iniciar sesión';
  env = environment;

  public user: User = new User();
  loading: boolean;
  form: FormGroup;
  hide: boolean = true;

  constructor( private auth: AuthService,
               private router: Router,
               private fb: FormBuilder,
               private snackBar: MatSnackBar) {

    this.loading = false;
    this.form = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
   }

  ngOnInit(): void {
    if (this.auth.isAuthenticated()) {
      this.router.navigate(['/']);
    }
  }

  public login(): void {
    const val = this.form.value;
    if (val.username && val.password) {
      this.loading = true;
      this.auth.login(val.username, val.password).subscribe((response) => {
        this.router.navigate(['/']);
        this.auth.authUpdate();
        this.loading = false;


      }, err => {
        this.loading = false;
        if (err.includes("400")) {
          this.form.reset();
          this.form.markAsDirty();
          this.snackBar.open("Credenciales inválidas", "x", {
            duration: 2000,
          });
        }else{
          this.snackBar.open(err, "x", {
            duration: 2000,
          });
        }
      });
    }
  }



}
